export const recovery_intro = {
  title: "Reset your password",
  link_login: "Back to sign in",
  dev_recovery_hint:
    "In local development, open Vue DevTools, select the Server logs tab, and look for your recovery code there.",
};
